import { api } from "../http";

export type EmergencyAlertRequest = {
  categories: string[];
  comment?: string;
  triggeredAt?: string;
  audience?: string;
};

export type EmergencyAlertResponse = {
  id: string;
  categories?: string[];
  comment?: string | null;
  triggeredAt?: string | null;
  receivedAt?: string | null;
  pendingAuthorization?: boolean;
};

export const emergencyAlertsApi = {
  create(payload: EmergencyAlertRequest) {
    return api.post<EmergencyAlertResponse, EmergencyAlertRequest>("/api/emergency-alerts", payload);
  },
  authorize(id: string) {
    return api.post<EmergencyAlertResponse, void>(
      `/api/emergency-alerts/${encodeURIComponent(id)}/authorize`,
    );
  },
  listRecent(params: { facilityId?: string; limit?: number } = {}) {
    const searchParams = new URLSearchParams();
    if (params.facilityId) {
      searchParams.set("facilityId", params.facilityId);
    }
    if (typeof params.limit === "number") {
      searchParams.set("limit", String(params.limit));
    }
    const query = searchParams.toString();
    return api.get<EmergencyAlertResponse[]>(`/api/emergency-alerts${query ? `?${query}` : ""}`);
  },
};
